import { render, staticRenderFns } from "./SolicitacoesAditivos.vue?vue&type=template&id=68d77a0c"
import script from "./SolicitacoesAditivos.vue?vue&type=script&lang=js"
export * from "./SolicitacoesAditivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports